export enum LoginStep {
  Login = "login",
  Authentication = "authentication",
  Verification = "verification",
  End = "end",
}